import styled from 'styled-components'

export const Backwards = styled.div`
	display: flex;
	:before {
    content: '';
    position: unset !important;
   	width: 0;
		height: 0;
		border-style: solid;
		border-width: 3px 6px 3px 0;
		border-color: transparent #fff transparent transparent;
		position:
	}
`
export const Forward = styled.div`
    display: flex;
		:before {
			content: '';
			position: unset !important;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 3px 0 3px 6px;
			border-color: transparent transparent transparent #fff;
		}
`
